import axios from '@/plugins/axios';
const BASE_URL = '/api/cache';

export const getCaches = async () => {
    const response = await axios.get(`${BASE_URL}/info`);
    return response.data;
};

export const getCacheStats = async () => {
    const response = await axios.get(`${BASE_URL}/stats`);
    return response.data;
};

export const deleteCache = async (cacheKey) => {
    const encodedKey = encodeURIComponent(cacheKey);
    const response = await axios.post(`${BASE_URL}/delete/${encodedKey}`);
    return response.data;
};